function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M18 15.053v0a3 3 0 01-3-3v-6a3 3 0 013-3v0M18 3.053h1a1 1 0 011 1v17M18 15.05h2M6.5 11.55L6.49 21M6.5 8.55V3M3 3.084v4.552-.09c0 2.209 1.567 4 3.5 4s3.5-1.791 3.5-4v.09-4.552",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgForkKnife(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgForkKnife;